import { render, staticRenderFns } from "./AddStudentComponent.vue?vue&type=template&id=6304036a&"
import script from "./AddStudentComponent.vue?vue&type=script&lang=js&"
export * from "./AddStudentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports